import React, { Component } from 'react';
import css from './CustomInputField.module.scss';
import { cleanString } from '../../../helpers';

export default class CustomInputField extends Component {
  state = {
    displayPassword: false
  };

  onInput = e => {
    e.preventDefault();
    if (this.props.onInput) {
      this.props.onInput(cleanString(e.target.value));
    }
  };

  onChange = e => {
    e.preventDefault();
    if (this.props.onChange) {
      this.props.onChange(cleanString(e.target.value));
    }
  };

  toggleDisplayPassword = () => {
    this.setState({
      displayPassword: !this.state.displayPassword
    });
  };

  render() {
    const {
      placeholder,
      format,
      options,
      error,
      onInput,
      onChange,
      rawValue,
      icon,
      tidy,
      disabled,
      id,
      type,
      passwordEyeball,
      allowFullStory,
      hideLabel,
      smallerMarginBottom,
      ...rest
    } = this.props;

    return (
      <div
        className={`${css.field} ${css.CustomInputFieldGroup} 
        ${!allowFullStory && 'fs-mask'} 
        ${smallerMarginBottom && css.smallerMarginBottom} 
        ${hideLabel && css.hideLabel}`}
      >
        <label
          htmlFor={id}
          hidden={hideLabel}
          data-e2e={
            error &&
            `error-message-${placeholder
              .toLowerCase()
              .replace(/ /g, '-')
              .replace(/'/g, '')}`
          }
        >
          {placeholder}
        </label>
        <div className={css.inputGroup}>
          <input
            {...rest}
            onInput={this.onInput}
            onChange={this.onChange}
            className={`${passwordEyeball ? css.passwordInput : ''}`}
            id={id}
            type={this.state.displayPassword ? 'text' : type}
            data-e2e={`${placeholder
              .toLowerCase()
              .replace(/ /g, '-')
              .replace(/'/g, '')}`}
          />
          {error && (
            <img
              className={css.errorIcon}
              data-testid="custom-input-error-icon"
              src="/static/error-icon.svg"
              alt="Input Error Icon"
            />
          )}
        </div>
        {passwordEyeball && (
          <img
            className={css.eyeball}
            data-testid="eyeball"
            onClick={this.toggleDisplayPassword}
            src={
              this.state.displayPassword
                ? '../../../static/eyecon-hide.png'
                : '../../../static/eyecon-show.png'
            }
            alt="Show Password"
          />
        )}
        <span
          className={`${css.bar} ${error ? css.error : ''} ${
            passwordEyeball && css.password
          }`}
        />
        <span
          data-testid="format-text"
          className={`${css.formatLabel} ${error ? css.error : ''}`}
        >
          {format}
        </span>
        {!!icon && icon}
      </div>
    );
  }
}
